import React, { createContext, useContext, useState } from 'react';
const TabsSaver = ({ children }) => {
    const [lastTab, setLastTab] = useState();
    return (<TabsSaverContext.Provider value={{
        lastTab,
        setLastTab,
    }}>
      {children}
    </TabsSaverContext.Provider>);
};
export default TabsSaver;
export const useTabsSaver = () => {
    useContext(TabsSaverContext);
};
export const TabsSaverContext = createContext({});
